import { ProductListing } from "@domain/product/models/ProductListing";
import { ProductListingDTO } from "../dto/ProductListingDTO";
import { ConnectionMapper } from "@infrastructure/connection/mappers/ConnectionMapper";
import { Connection } from "@domain/connection/models/Connection";
import { ProductMapper } from "./ProductMapper";

export class ProductListingMapper {
  static toModel(dto: ProductListingDTO): ProductListing {
    return {
      id: dto.id,
      ean: dto.ean,
      product: dto.product ? ProductMapper.toModel(dto.product) : undefined,
      connection: dto.connection ? ConnectionMapper.toModel(dto.connection) : (undefined as unknown as Connection),
      marketplace: dto.marketplace,
      country: dto.country,
      title: dto.title,
      image: dto.image,
      active: dto.active,
      url: dto.url,
    };
  }
}
